import React, { Fragment } from 'react'

/**Component for implementing loader effect
 * @param  {boolean} {isLoading}
 */
const Loader = ({ isLoading }) => {
    return (
        <Fragment>
            {/* For loading state */}
            {isLoading && <div className='loader'></div>}
        </Fragment>
    )
}

export { Loader }
